//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'WellsPE2',
  data() {
    return {
      defaultJson:{
        "signs": "深静脉血栓临床症状和体征",
        "PE likely": "PE 可能",
        "malignancyhint": "正在治疗、过去 6 月内接受过治疗或姑息性治疗",
        "PE unlikely": "PE 不可能",
        "hemoptysis": "咯血",
        "signshint": "单下肢轻度肿胀伴深静脉压痛",
        "malignancy": "活动性恶性肿瘤",
        "mostlikely": "PE 是最可能的诊断",
        "previous": "DVT 或 PE 既往史",
        "surgery": "过去四周内有制动或手术史",
        "tachycardia": "心律失常（> 100 bpm）"
      },
      form:{
        signs:'0',
        mostlikely:'0',
        tachycardia:'0',
        surgery:'0',
        previous:'0',
        hemoptysis:'0',
        malignancy:'0',
      },
      hasScore:false,
      disabled:false,
      descTxt:'',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.signs * 3 + form.mostlikely * 3 + form.tachycardia * 1.5 + form.surgery * 1.5 + form.previous * 1.5 + form.hemoptysis + form.malignancy
      self.hasScore = true
      if (result>4) {
        self.descTxt = 'PE 可能'
      } else {
        self.descTxt = 'PE 不可能'
      }
      return String(result)
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/WellsPE2.vue